import getStore from '../store/store';
import UserOptions from '../store/schema/UserOptions';
import LoadState from '../store/schema/LoadState';
import { loadOptions } from '../actions/loadOptions';

export default function getUserOptions(onOptionsReady?: (userOptions: UserOptions) => void) {
    const store = getStore();
    if (
        store.optionsLoadState === LoadState.NotLoaded ||
        store.optionsLoadState === LoadState.Loading
    ) {
        loadOptions(() => {
            if (onOptionsReady) {
                onOptionsReady(getStore().userOptions);
            }
        });
    } else if (store.optionsLoadState === LoadState.Loaded) {
        if (onOptionsReady) {
            onOptionsReady(getStore().userOptions);
        }
    }
}
